(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2771],{

/***/ 25845:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/profile",
      function () {
        return __webpack_require__(74411);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81043);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69587);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46607);
/* harmony import */ var _api_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65564);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7597);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67707);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_account_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _store_customer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97331);
/* harmony import */ var _hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76210);
/* harmony import */ var _shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64465);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84444);
/* harmony import */ var _AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81111);
/* harmony import */ var _store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64514);




















var AccountLayout = function(param) {
    var children = param.children, breadcrumb = param.breadcrumb, translationsData = param.translationsData, selectedLocale = param.selectedLocale, dbName = param.dbName;
    var selectedRate = (0,_hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__/* .useGlobal */ .O)().selectedRate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), links = ref[0], setLinks = ref[1];
    var history = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var cartToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    }).cartToken;
    var isDownloadableOrder = !!(0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.orders.downloadable;
    }).length;
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var baseLinks = [
            {
                id: 1,
                url: "profile",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Profile */ .NZ, {}),
                title: translationsData.PersonalInformation
            },
            {
                id: 2,
                url: "orders",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Orders */ .We, {
                    className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["historyIcon-svg"])
                }),
                title: translationsData.MyOrders
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(isDownloadableOrder ? [
            {
                id: 3,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .DownloadIcon */ ._8, {}),
                url: "downloadable-products",
                title: translationsData.DownloadableProducts
            }
        ] : []), [
            {
                id: 4,
                url: "addresses",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Addresses */ .sA, {}),
                title: translationsData.Address
            },
            {
                id: 5,
                url: "logout",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Logout */ .RD, {}),
                title: translationsData.SignOut
            }
        ]);
        setLinks(baseLinks);
    }, [
        isDownloadableOrder
    ]);
    var logout = function(e) {
        e.preventDefault();
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setAuth */ .QV)(false));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setCustomerGroupID */ .KJ)(1));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setToken */ .o4)(""));
        dispatch((0,_store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__/* .clearOrders */ .oh)());
        _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCustomerLogoutToken(customer.token).then(function(item) {
            if (item.ok) {
                _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCheckoutCartToken().then(function(res) {
                    if (res.api_token) {
                        dispatch((0,_store_token__WEBPACK_IMPORTED_MODULE_7__/* .AddCartToken */ .y)(res.api_token));
                    }
                });
            }
        });
        dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_9__/* .getCartDataMount */ .yU)(cartToken, {
            token: ""
        }, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_17__/* .wishListRemoveAllItems */ .XZ)());
        history.push("/");
    };
    var newLinks = links.map(function(link) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item"]), history.route.includes(link.url) && (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item--active"]));
        var signOutProps = link.url === "logout" ? {
            onClick: logout,
            className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logout)
        } : {};
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/account/".concat(link.url),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, signOutProps), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: link.icon
                        }),
                        link.title
                    ]
                }))
            })
        }, link.id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__title"]),
                children: translationsData.MyAccount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().block),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                links: newLinks
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout"]), " ").concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-desktop"])),
                                children: children
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountLayout);


/***/ }),

/***/ 76210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68912);



/***/ }),

/***/ 74411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ profile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/account/AccountLayout.tsx
var AccountLayout = __webpack_require__(93487);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
// EXTERNAL MODULE: ./atoms/index.ts + 1 modules
var atoms = __webpack_require__(69607);
// EXTERNAL MODULE: ./atoms/customFields/TextField.tsx
var TextField = __webpack_require__(14125);
// EXTERNAL MODULE: ./atoms/customFields/TextArea.tsx
var TextArea = __webpack_require__(9881);
// EXTERNAL MODULE: ./atoms/customFields/DropDown.tsx
var DropDown = __webpack_require__(38334);
// EXTERNAL MODULE: ./atoms/customFields/DateField.tsx
var DateField = __webpack_require__(5740);
// EXTERNAL MODULE: ./atoms/customFields/YesNoRadio.tsx
var YesNoRadio = __webpack_require__(2296);
// EXTERNAL MODULE: ./atoms/customFields/RadioButton.tsx
var RadioButton = __webpack_require__(18581);
// EXTERNAL MODULE: ./atoms/customFields/SelectField.tsx
var SelectField = __webpack_require__(95415);
// EXTERNAL MODULE: ./components/account/account.module.scss
var account_module = __webpack_require__(67707);
var account_module_default = /*#__PURE__*/__webpack_require__.n(account_module);
// EXTERNAL MODULE: ./store/customer/index.js + 3 modules
var store_customer = __webpack_require__(97331);
;// CONCATENATED MODULE: ./components/account/AccountPageProfile.tsx



















var initialState = {
    first_name: "",
    last_name: "",
    email: "",
    gender: "Male",
    date_of_birth: "",
    companyname: ""
};
var AccountPageProfile = function(param) {
    var customFieldGenerate = param.customFieldGenerate, translationsData = param.translationsData;
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(), address = ref[0], setAddress = ref[1];
    var ref1 = (0,react.useState)(), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,react.useState)(initialState), input = ref3[0], setInput = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(true), urlValidate = ref5[0], setUrlValidate = ref5[1];
    var handleChange = function(event, code) {
        var _target = event.target, name = _target.name, value = _target.value;
        var regexDecimal = /^\d+(\.\d{0,100})?$/;
        var regexInteger = /^\d+$/;
        var regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
        var regexLettersOnly = /^[a-zA-Z]+$/;
        var regexLettersAndNumbersOnly = /^[a-zA-Z0-9]+$/;
        var filterValue = function() {
            if (code === "decimal" && !regexDecimal.test(value)) {
                if (regexDecimal.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "integer" && !regexInteger.test(value)) {
                if (regexInteger.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "url") {
                setUrlValidate(value !== "" ? regexUrl.test(value) : true);
            }
            if (code === "letter" && !regexLettersOnly.test(value)) {
                if (regexLettersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "letter_number" && !regexLettersAndNumbersOnly.test(value)) {
                if (regexLettersAndNumbersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            return value;
        };
        setInput((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), (0,_define_property/* default */.Z)({}, name, filterValue())));
    };
    (0,react.useEffect)(function() {
        var abortController = new AbortController();
        var signal = abortController.signal;
        if (customer.token) {
            fetch((0,helper/* apiUrlWithStore */.St)("/api/customer/get?token=".concat(customer.token)), {
                signal: signal
            }).then(function(response) {
                return response.json();
            }).then(function(res) {
                if (res) {
                    var gender = "Male";
                    var date_of_birth = "1999-09-09";
                    setInput((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res.data), {
                        gender: gender,
                        date_of_birth: date_of_birth
                    }));
                    setAddress((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res.data), {
                        gender: gender
                    }));
                }
            }).catch(function(err) {
                return console.error(err);
            });
        }
        return function cleanUp() {
            abortController.abort();
        };
    }, [
        customer.token
    ]);
    if (!address) {
        return null;
    }
    var handleClick = function(event) {
        var newBodyResponse = (0,_object_spread/* default */.Z)({
            date_of_birth: input.date_of_birth,
            email: input.email,
            first_name: input.first_name,
            gender: "Male",
            last_name: input.last_name,
            phone: input.phone,
            token: customer.token
        }, input);
        dispatch((0,store_customer/* setCompanyName */._4)(input.companyname));
        event.preventDefault();
        setLoading(true);
        var option = {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newBodyResponse)
        };
        fetch((0,helper/* apiUrlWithStore */.St)("/api/customer/profile"), option).then(function(response) {
            return response.json();
        }).then(function(res) {
            setLoading(false);
            if (res.errors) {
                setErrors(res.errors);
            } else {
                setSuccess(true);
                setErrors(undefined);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((account_module_default()).card, " ").concat((account_module_default())["input-fields-parent"]),
        children: [
            success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert alert-success",
                children: translationsData.AccountUpdatedSuccessfully
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (account_module_default())["card-body"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex ".concat((account_module_default())["personal-info-card"]),
                            children: [
                                customFieldGenerate.map(function(item, index) {
                                    switch(item.type){
                                        case "textfield":
                                            if (item.attribute_code === "contactpersonphonenumber") {
                                                return null;
                                            } else if (item.attribute_code === "contactpersonemail") {
                                                return null;
                                            } else {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        item: item,
                                                        index: index,
                                                        // @ts-ignore
                                                        savedFormData: (input === null || input === void 0 ? void 0 : input[item.attribute_code]) ? input : address,
                                                        handleChange: handleChange,
                                                        urlValidate: urlValidate,
                                                        translationsData: translationsData,
                                                        setCompanyName: store_customer/* setCompanyName */._4
                                                    })
                                                });
                                            }
                                        case "textarea":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                                    item: item,
                                                    index: index,
                                                    // @ts-ignore
                                                    savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address,
                                                    handleChange: handleChange,
                                                    translationsData: translationsData
                                                })
                                            });
                                        case "dropdown":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown/* default */.Z, {
                                                    item: item,
                                                    index: index,
                                                    // @ts-ignore
                                                    savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address,
                                                    handleChange: handleChange,
                                                    translationsData: translationsData
                                                })
                                            });
                                        case "date":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                    item: item,
                                                    index: index,
                                                    // @ts-ignore
                                                    savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address,
                                                    handleChange: handleChange,
                                                    translationsData: translationsData
                                                })
                                            });
                                        case "boolean":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YesNoRadio/* default */.Z, {
                                                    //@ts-ignore
                                                    savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address,
                                                    item: item,
                                                    index: index,
                                                    handleChange: handleChange,
                                                    translationsData: translationsData
                                                })
                                            });
                                        case "radio":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                                    //@ts-ignore
                                                    savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address,
                                                    item: item,
                                                    index: index,
                                                    handleChange: handleChange,
                                                    translationsData: translationsData
                                                })
                                            });
                                        case "multiselect":
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* default */.Z, {
                                                item: item,
                                                index: index,
                                                translationsData: translationsData,
                                                handleChange: handleChange,
                                                // @ts-ignore
                                                savedFormData: (input === null || input === void 0 ? void 0 : input.hasOwnProperty(item.attribute_code)) ? input : address
                                            });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                            handleChange: handleChange,
                                            name: "email",
                                            value: translationsData.Email,
                                            inpValue: input.email,
                                            type: "email"
                                        }),
                                        errors && errors.email !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "alert-danger",
                                            children: translationsData.TheEmailMustBeAValidEmailAddress
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                    style: {
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: (account_module_default())["button-change-password"],
                                        style: {
                                            background: "transparent"
                                        },
                                        onClick: function() {
                                            dispatch((0,general/* setPopup */.ZA)(true));
                                            dispatch((0,general/* setPopupName */.Sq)("passwordChange"));
                                        },
                                        children: [
                                            translationsData.ChangePassword,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ChangepasSvg */.Yl, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        handleChange: function(e) {
                                            return handleChange(e, "integer");
                                        },
                                        name: "phone",
                                        value: translationsData.Phone,
                                        inpValue: input.phone,
                                        type: "phone"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["account-contact_person"],
                        children: translationsData.ContactPerson + ":"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (account_module_default()).card_grid,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        name: "first_name",
                                        handleChange: handleChange,
                                        inpValue: input.first_name,
                                        value: translationsData.FirstName
                                    }),
                                    errors && errors.first_name !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.TheFirstNameFieldIsRequired
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                        name: "last_name",
                                        handleChange: handleChange,
                                        inpValue: input.last_name,
                                        value: translationsData.LastName
                                    }),
                                    errors && errors.last_name !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "alert-danger",
                                        children: translationsData.TheLastNameFieldIsRequired
                                    })
                                ]
                            }),
                            customFieldGenerate.map(function(item, index) {
                                switch("".concat(item.type, "-").concat(item.attribute_code)){
                                    case "textfield-contactpersonemail":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                            style: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                item: item,
                                                index: index,
                                                translationsData: translationsData,
                                                // @ts-ignore
                                                savedFormData: (input === null || input === void 0 ? void 0 : input[item.attribute_code]) ? input : address,
                                                handleChange: handleChange,
                                                urlValidate: urlValidate
                                            })
                                        });
                                    case "textfield-contactpersonphonenumber":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((account_module_default())["form-group"], " ").concat((account_module_default())["input-paddings"]),
                                            style: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                item: item,
                                                index: index,
                                                translationsData: translationsData,
                                                // @ts-ignore
                                                savedFormData: (input === null || input === void 0 ? void 0 : input[item.attribute_code]) ? input : address,
                                                handleChange: handleChange,
                                                urlValidate: urlValidate
                                            })
                                        });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["account-save-profile"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleClick,
                            type: "button",
                            className: !loading ? "btn btn-primary btn-primary-fms" : "btn btn-primary btn-primary-fms",
                            children: translationsData.SaveChanges
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var account_AccountPageProfile = (AccountPageProfile);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 29 modules
var MainLayout = __webpack_require__(84980);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/account/profile.tsx











var Profile = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, customFieldGenerate = pageProps.customFieldGenerate, breadcrumb = pageProps.breadcrumb, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var router = (0,next_router.useRouter)();
    var meta_title = "My Personal Account";
    var meta_description = "My Personal Account for ".concat(dbName, " website ");
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    (0,react.useEffect)(function() {
        if (!customer.token && !customer.authenticated) {
            router.push("/").then(function(r) {
                return r;
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
                    dbName: dbName,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData,
                    selectedLocale: selectedLocale,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_AccountPageProfile, {
                        customFieldGenerate: customFieldGenerate,
                        translationsData: translationsData
                    })
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var profile = (Profile);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,7992,3997,7352,9774,2888,179], function() { return __webpack_exec__(25845); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);